import { all } from "redux-saga/effects"

import allSaga from "./all/saga"

function* countrySaga() {
  yield all([allSaga()])
}

export default countrySaga
